import { useMemo } from 'react';
import { useDisplayWebContentSelector } from './useDisplayWebContentSelector';

export const useEmbeddedSettingsSelector = ({ messageId }: { messageId: string }) => {
  const message = useDisplayWebContentSelector({ messageId });
  return useMemo(
    () => ({
      selector: message?.embeddedSelector,
      position: message?.embeddedPosition,
    }),
    [message?.embeddedPosition, message?.embeddedSelector],
  );
};
